module.exports = __webpack_public_path__ + "2a274f88fbe2f50527d764ffff7f21e4.svg";